<template>
  <div class="promotions" ref="promotionsContainer">
    <div class="button-container">
      <button
        class="btn btn-tabs"
        v-for="(tab, i) in tabs"
        :key="i"
        :class="{ active: isActive(tab) }"
        @click="navigateTo(tab)"
      >
        {{ $t(tab.name) }}
      </button>
      <!-- <div>
        <img
          style="position: absolute; right: 0; padding: 15px"
          src="@/static/images/arrow-right.svg"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgencyTabNavigation',
  data() {
    return {
      currentTab: null,
    }
  },
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => [
        { name: 'Invite', link: '/agency-center/invite' },
        { name: 'Agent', link: '/agency-center/agent' },
        { name: 'Invitation record', link: '/agency-center/invitation-record' },
        { name: 'Reward', link: '/agency-center/reward' },
        { name: 'Agency mechanism', link: '/agency-center/agency-mechanism' },
        {
          name: 'Register subordinates',
          link: '/agency-center/register-subordinates',
        },
      ],
    },
  },
  methods: {
    navigateTo(tab) {
      // Save the current scroll position in localStorage
      localStorage.setItem(
        'navScrollPosition',
        this.$refs.promotionsContainer.scrollLeft
      )

      // Set the active tab and navigate to the route
      this.currentTab = tab
      this.$router.push({ path: tab.link })
    },
    isActive(tab) {
      // Check if the tab is currently active based on the route
      return this.$route.fullPath.includes(tab.link)
    },
    restoreScrollPosition() {
      // Restore the saved scroll position from localStorage
      const savedPosition = localStorage.getItem('navScrollPosition')
      if (savedPosition) {
        this.$refs.promotionsContainer.scrollLeft = parseInt(savedPosition, 10)
      }
    },
  },
  mounted() {
    // Set the current tab based on the current route when the component is mounted
    const currentPath = this.$route.path
    this.currentTab = this.tabs.find((tab) => tab.link === currentPath)

    // Restore the scroll position if previously saved
    this.restoreScrollPosition()
  },
  watch: {
    // Watch for route changes and restore the scroll position after navigation
    $route() {
      this.restoreScrollPosition()
    },
  },
}
</script>

<style lang="less" scoped>
.promotions {
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/agencyCenter/tabNavigation.vue